import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    Grid2,
    Button
} from "@mui/material";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SingleFileUpload from "../../../fileUpload/FileUpload";
import OtherTopics from "./OtherTopics";
import { useDispatch, useSelector } from "react-redux";
import { fetchProcessDetails, updateProcess } from "../../../../store/startup/aboutProduct/processSlice";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';

const Process = () => {
    const dispatch = useDispatch();
    const { startupId } = useParams();
    
    // Selector'ı daha savunmacı bir şekilde yazalım
    const processState = useSelector((state) => state.process || {});
    const processDetails = processState.processDetails || null;
    const loading = processState.loading || false;
    const error = processState.error || null;

    const [errors, setErrors] = useState({});

    // Local state for form values
    const [developmentProcesses, setDevelopmentProcesses] = useState("");
    const [productionProcesses, setProductionProcesses] = useState("");
    const [potentialByproducts, setPotentialByproducts] = useState("");
    const [technicalAndDesignAnalysis, setTechnicalAndDesignAnalysis] = useState("");
    const [rAndDActivities, setRAndDActivities] = useState("");
    const [previousSales, setPreviousSales] = useState("");
    const [developmentDocumentPath, setDevelopmentDocumentPath] = useState("");
    const [productionDocumentPath, setProductionDocumentPath] = useState("");
    const [byproductsDocumentPath, setByproductsDocumentPath] = useState("");
    const [designAnalysisDocumentPath, setDesignAnalysisDocumentPath] = useState("");
    const [rAndDDocumentPath, setRAndDDocumentPath] = useState("");
    const [previousSalesDocumentPath, setPreviousSalesDocumentPath] = useState("");

    // Fetch data on component mount
    useEffect(() => {
        if (startupId) {
            dispatch(fetchProcessDetails(startupId));
        }
    }, [dispatch, startupId]);

    // Update local state when Redux state changes
    useEffect(() => {
        console.log("Process Details:", processDetails); // Debug için log ekleyelim
        if (processDetails) {
            setDevelopmentProcesses(processDetails.developmentProcesses || "");
            setProductionProcesses(processDetails.productionProcesses || "");
            setPotentialByproducts(processDetails.potentialByproducts || "");
            setTechnicalAndDesignAnalysis(processDetails.technicalAndDesignAnalysis || "");
            setRAndDActivities(processDetails.rAndDActivities || "");
            setPreviousSales(processDetails.previousSales || "");
            
            // Dosya yollarını set et
            setDevelopmentDocumentPath(processDetails.developmentDocumentPath || "");
            setProductionDocumentPath(processDetails.productionDocumentPath || "");
            setByproductsDocumentPath(processDetails.byproductsDocumentPath || "");
            setDesignAnalysisDocumentPath(processDetails.designAnalysisDocumentPath || "");
            setRAndDDocumentPath(processDetails.rAndDDocumentPath || "");
            setPreviousSalesDocumentPath(processDetails.previousSalesDocumentPath || "");
            
            // Debug için log
            console.log("Process Details Document Paths:", {
                developmentDocumentPath: processDetails.developmentDocumentPath,
                productionDocumentPath: processDetails.productionDocumentPath,
                byproductsDocumentPath: processDetails.byproductsDocumentPath,
                designAnalysisDocumentPath: processDetails.designAnalysisDocumentPath,
                rAndDDocumentPath: processDetails.rAndDDocumentPath,
                previousSalesDocumentPath: processDetails.previousSalesDocumentPath
            });
        }
    }, [processDetails]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!developmentProcesses.trim()) {
            newErrors.developmentProcesses = "Gelişim süreçleri zorunludur";
        }
        if (!productionProcesses.trim()) {
            newErrors.productionProcesses = "Üretim süreçleri zorunludur";
        }
        if (!potentialByproducts.trim()) {
            newErrors.potentialByproducts = "Yan ürünler zorunludur";
        }
        if (!technicalAndDesignAnalysis.trim()) {
            newErrors.technicalAndDesignAnalysis = "Teknik ve tasarımsal analizler zorunludur";
        }
        if (!rAndDActivities.trim()) {
            newErrors.rAndDActivities = "AR-GE faaliyetleri zorunludur";
        }
        if (!previousSales.trim()) {
            newErrors.previousSales = "Önceki satışlar zorunludur";
        }
        /*
        if (!developmentDocumentPath) {
            newErrors.developmentDocumentPath = "Gelişim süreçleri dokümanı zorunludur";
        }
        if (!productionDocumentPath) {
            newErrors.productionDocumentPath = "Üretim süreçleri dokümanı zorunludur";
        }
        if (!byproductsDocumentPath) {
            newErrors.byproductsDocumentPath = "Yan ürünler dokümanı zorunludur";
        }
        if (!designAnalysisDocumentPath) {
            newErrors.designAnalysisDocumentPath = "Teknik ve tasarımsal analizler dokümanı zorunludur";
        }
        if (!rAndDDocumentPath) {
            newErrors.rAndDDocumentPath = "AR-GE faaliyetleri dokümanı zorunludur";
        }
        if (!previousSalesDocumentPath) {
            newErrors.previousSalesDocumentPath = "Önceki satışlar dokümanı zorunludur";
        } */

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateForm()) {
            return;
        }

        const updatedInfo = {
            startupId,
            developmentProcesses,
            productionProcesses,
            potentialByproducts,
            technicalAndDesignAnalysis,
            rAndDActivities,
            previousSales,
            developmentDocumentPath,
            productionDocumentPath,
            byproductsDocumentPath,
            designAnalysisDocumentPath,
            rAndDDocumentPath,
            previousSalesDocumentPath,
        };
        dispatch(updateProcess(updatedInfo));
    };

    return (
        <div>
            <Typography variant="h5" sx={{ marginTop: 6 }} gutterBottom>
                Süreçler Hakkında
            </Typography>
            <Divider sx={{ marginBottom: 3, bgcolor: 'black' }} />

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            Ürünün/Projenin Gelişim Süreçleri Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={developmentProcesses} 
                            onChange={setDevelopmentProcesses} 
                            style={{ height: '60%' }} 
                        />
                        {errors.developmentProcesses && (
                            <Typography color="error" variant="caption">
                                {errors.developmentProcesses}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setDevelopmentDocumentPath(path)}
                            onUploadComplete={(path) => setDevelopmentDocumentPath(path)}
                            existFilePath={developmentDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.developmentDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.developmentDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            Ürünün/Projenin Üretim Süreçleri Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={productionProcesses} 
                            onChange={setProductionProcesses} 
                            style={{ height: '60%' }} 
                        />
                        {errors.productionProcesses && (
                            <Typography color="error" variant="caption">
                                {errors.productionProcesses}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setProductionDocumentPath(path)}
                            onUploadComplete={(path) => setProductionDocumentPath(path)}
                            existFilePath={productionDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.productionDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.productionDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            Ortaya Çıkabilecek Yan Ürünler Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={potentialByproducts} 
                            onChange={setPotentialByproducts} 
                            style={{ height: '60%' }} 
                        />
                        {errors.potentialByproducts && (
                            <Typography color="error" variant="caption">
                                {errors.potentialByproducts}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setByproductsDocumentPath(path)}
                            onUploadComplete={(path) => setByproductsDocumentPath(path)}
                            existFilePath={byproductsDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.byproductsDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.byproductsDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            Teknik ve Tasarımsal Analizler Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={technicalAndDesignAnalysis} 
                            onChange={setTechnicalAndDesignAnalysis} 
                            style={{ height: '60%' }} 
                        />
                        {errors.technicalAndDesignAnalysis && (
                            <Typography color="error" variant="caption">
                                {errors.technicalAndDesignAnalysis}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setDesignAnalysisDocumentPath(path)}
                            onUploadComplete={(path) => setDesignAnalysisDocumentPath(path)}
                            existFilePath={designAnalysisDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.designAnalysisDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.designAnalysisDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            AR-GE Faaliyetleri Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={rAndDActivities} 
                            onChange={setRAndDActivities} 
                            style={{ height: '60%' }} 
                        />
                        {errors.rAndDActivities && (
                            <Typography color="error" variant="caption">
                                {errors.rAndDActivities}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setRAndDDocumentPath(path)}
                            onUploadComplete={(path) => setRAndDDocumentPath(path)}
                            existFilePath={rAndDDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.rAndDDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.rAndDDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 8 }}>
                    <Box sx={{ mb: 1, width: '100%', height: '300px' }}>
                        <Typography variant="h6" gutterBottom>
                            Önceki Satışlar Hakkında Özet Bilgi
                        </Typography>
                        <ReactQuill 
                            theme="snow" 
                            value={previousSales} 
                            onChange={setPreviousSales} 
                            style={{ height: '60%' }} 
                        />
                        {errors.previousSales && (
                            <Typography color="error" variant="caption">
                                {errors.previousSales}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4 }}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} >
                        <SingleFileUpload 
                            onFileUpload={(path) => setPreviousSalesDocumentPath(path)}
                            onUploadComplete={(path) => setPreviousSalesDocumentPath(path)}
                            existFilePath={previousSalesDocumentPath}
                            fileUploadPath="startup"
                        />
                        {errors.previousSalesDocumentPath && (
                            <Typography color="error" variant="caption">
                                {errors.previousSalesDocumentPath}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            </Grid2>

            <Box sx={{ marginTop: 4, textAlign: "right" }}>
                <Button 
                    color="primary"
                    variant="contained" 
                    onClick={handleSave}
                >
                    {loading ? 'Kaydediliyor...' : 'Kaydet'}
                </Button>
            </Box>

            <Divider sx={{ marginBottom: 3 }} />

            <Box sx={{ mt: 4, p: 2, borderRadius: 1 }}>

                <OtherTopics />
            </Box>

            
        </div>
    )
}

export default Process;